import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import SEimg from '../../../images/seimg_1.svg';
import { appStore, googlePlay } from '../../../images/welcome';
import { ROUTE } from '../../App';
import { Logotype } from '../../components';
import cn from '../../lib/classNames';

import styles from './LayoutStartedOld.module.scss';

const { userAgent } = navigator;
const isIOS = userAgent.includes('safeesteem-personal-edition-ios-app');

type LayoutStartedType = {
	children: ReactNode;
	displayStoreButtons?: boolean;
};

export default function LayoutStartedOld(props: LayoutStartedType) {
	const { children, displayStoreButtons = false } = props;

	return (
		<div className={styles['page-get-started']}>
			<div className={cn(styles.content, 'content')}>
				<header className={styles['header-top']}>
					<Link className={styles.logo} to={ROUTE.default}>
						<Logotype />
					</Link>
				</header>
				<main className={styles.main}>
					<div className={cn(styles['box-left'], 'mob-hide')}>
						<div>
							<h1>
								<span>Safe-xplore AI</span>
							</h1>
							<p>
								Live and travel with confidence by understanding your risks at home or when
								traveling.
							</p>
							{displayStoreButtons && !isIOS && (
								<div className={styles['app-download-container']}>
									<div className={styles['btn-store']}>
										<a href="https://apple.co/3pQ5dya">
											<img src={appStore} alt="Download on the App Store" />
										</a>
									</div>
									<div className={styles['btn-store']}>
										<a href="https://play.google.com/store/apps/details?id=com.safexplore">
											<img src={googlePlay} alt="Download on the Google Play" />
										</a>
									</div>
								</div>
							)}
							<a
								className={styles.link}
								href="https://safe-esteem.typeform.com/sxpeintro"
								target="_blank"
								rel="noreferrer"
							>
								LEARN MORE{' '}
								<span className={cn(styles['arrow-icon'], 'material-icons-round')}>
									arrow_forward
								</span>
							</a>
						</div>
						<div className={cn(styles['block-img'], styles.desktop)}>
							<img src={SEimg} alt="" />
						</div>
					</div>
					<div className={styles['box-right']}>{children}</div>
				</main>
			</div>
		</div>
	);
}
